import React, { useEffect, useRef } from "react";
//import React from 'react';
import * as actions from './Actions';
import Service from '../service/Service';

const service = new Service();
export default function ({ sideBarData, eleRef }) {
  var onChange=function(e) {
    
    var image = document.getElementById('output');
    image.src = URL.createObjectURL(e.target.files[0]);
}
  // //console.log("eleref in nonlogin",eleRef)
  const popupRef = useRef(null);
  
    useEffect(() => {
      const handleKeyDown = (e) => {
        const popupOverlay = document.querySelector(
          ".popUpPersonalised.addAns-overlay.popup.nonLog"
        );
        if (!popupOverlay) return;
  
        const isVisible = window.getComputedStyle(popupOverlay).display !== "none";
        if (!isVisible) return; // only work when popup is open
  
        const popup = popupRef.current;
        if (!popup) return;
  
        // ESC closes popup
        if (e.key === "Escape" || e.key === "Esc") {
          e.preventDefault();
          actions.closePopupcommon(eleRef);
          const prevFocusable = document.querySelector('[data-label="select-profile-child"]');
          if (prevFocusable) prevFocusable.focus();
          return;
        }
  
        // TAB: keep focus inside popup
        if (e.key === "Tab") {
          const focusableSelectors = `
            a[href], area[href], input:not([disabled]),
            select:not([disabled]), textarea:not([disabled]),
            button:not([disabled]), [tabindex]:not([tabindex="-1"])
          `;
  
          const focusableElements = Array.from(
            popup.querySelectorAll(focusableSelectors)
          ).filter((el) => el.offsetParent !== null); // visible elements only
  
          if (focusableElements.length === 0) return;
  
          const firstEl = focusableElements[0];
          const lastEl = focusableElements[focusableElements.length - 1];
          const activeEl = document.activeElement;
  
          // If Shift+Tab from first element → go to last
          if (e.shiftKey) {
            if (activeEl === firstEl || !popup.contains(activeEl)) {
              e.preventDefault();
              lastEl.focus();
            }
          } else {
            // Tab from last element → go to first
            if (activeEl === lastEl || !popup.contains(activeEl)) {
              e.preventDefault();
              firstEl.focus();
            }
          }
        }
      };
  
      // Attach global listener
      document.addEventListener("keydown", handleKeyDown);
  
      return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return (
    <div className="popUpPersonalised addAns-overlay popup nonLog"> 
        <div className="section_enter_child_detailsview" ref={popupRef}>
          <div className="close_popup_feeds_all" onClick={()=>{actions.closePopupcommon(eleRef)}} aria-label='Close profile popup' role='button' tabIndex={0} onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault(); // prevent scrolling when pressing Space
                actions.closePopupcommon(eleRef);
              } 
            }}>
           <span data-icon-font="C" className="icon"></span>
          </div>

            <div className="child_heading_popup M18_21" role="text" tabIndex={0} aria-label="Enter Child Details"> Enter Child Details</div>
            <div className="child_details_profile">
               <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png" alt="default profile" id="output"/>
                <div className="child_photo_upload_view" aria-label='Upload profile photo'>
                    <label className="add_photo_lbl" htmlFor="face_upload" >
                     <div className="child_Profile_edit"><span data-icon-font="H" className="icon"></span></div>
                    </label>
                </div>
                <input type="file" name="face_upload" id="face_upload" className="face_upload" accept="image/*" onChange={(e)=>onChange(e)} style={{ 'display': 'none' }} tabIndex={0} aria-label='Upload profile photo'/>
            </div>
            <div className="R14_link profile_heading2"> Add Profile Photo</div>
            <div className="child_details_profile_form">
               <form action="#" className="fieldset_details_form">
                 
                 <fieldset>
                   <legend htmlFor="child_date">Date of birth</legend>
                   <input type="text" placeholder="Enter Date of Birth" name="child_date" id="child_date" className="R14_42" readOnly  onKeyPress={(e) => service.onKeyPressDate(e)} onFocus={(e) => service.onFocusDate(e)} onBlur={(e) => service.onBlurDate(e)}/>
                   <span className="R15_21 tap_here"> </span>
                   <div className="fieldset_details_input_common " id="calendar-icon">
                      <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Calender_Icon.png" alt="Select date of birth"/>
                   </div>
                 </fieldset> 
                 <div className="child_enter_correct_dates R11_red" > </div>

                 <fieldset className="child_name_bottom-m">
                   <legend> Child name</legend>
                   <input type="text" name="Name" placeholder="Enter Child Name" id="child-name" tabIndex={0} aria-label='Enter Child Name'/>
                 </fieldset>

                 <div className="child_enter_correct_name R11_red" > </div>
                 <div className="child_details_genders">
                    <div className="left_gender_view"> 
                       <label className="duedate-radio-container" onClick={() => { this.checkForm("lmp") }} role="button" tabIndex={0} aria-label='Select gender Girl' onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.checkForm("lmp"); } }}>
                            <span className="child1234 R14_42">Girl</span>
                            <input id="lmp" type="radio" name="duedate-radio" />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                    <div className="right_gender_view"> 
                        <label className="duedate-radio-container" onClick={() => { this.checkForm("conception") }} role="button" tabIndex={0} aria-label='Select gender Boy' onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.checkForm("conception"); } }}>
                            <span className="child1234 R14_42"> Boy</span>
                            <input id="conception" type="radio" name="duedate-radio" />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                  </div>
                  <div className="child_details_btn_view"> 
                  <button className="M15_white" type="button" onClick={actions.OnPopupSubmit} tabIndex={0} aria-label='Submit profile' onKeyDown={(e) => { if (e.key === 'Enter') actions.OnPopupSubmit(); }}> Submit</button>
                  </div>
                  <div className="child_details_btn_submit"> 
                    <button className="M15_75" type="button" onClick={()=>{actions.closePopupcommon(eleRef)}} tabIndex={0} aria-label='Cancel button' onKeyDown={(e) => { if (e.key === 'Enter') actions.closePopupcommon(eleRef); }}> Cancel </button>
                  </div>
                  <div className="check_details_field">
                     
                     <span className="icon select-all checkbox checkAll" data-icon-font="z" id="setpic" value="0" onClick={(e) => { actions.pisTestdone(e) }} role="checkbox" tabIndex={0} aria-label="Don't prompt me again" onKeyDown={(e) => {
                       if (e.key === "Enter" || e.key === " ") {
                         e.preventDefault(); // prevent scrolling when pressing Space
                         actions.pisTestdone(e);
                       }
                     }}>
                     <span className="R13_42 check-text ">Don't prompt me again</span>
                     </span>
                  </div>
                </form>
            </div>
        </div>   
    </div>
)
}
